import React, {useEffect, useState} from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { useTranslation } from "react-i18next";
import { SearchPanel, TableCustom } from "../../components";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getDesinsectionRequests, addDesinsectionRequest, editDesinsectionRequest, deleteDesinsectionRequest, getDesinsectionRequestByKey } from "../../redux/actions/desinsectionRequestActions";
import CreateDesinsectionRequest from "./Popups/CreateDesinsectionRequest";
import DesinsectionRequestDetails from "./Popups/DesinsectionRequestDetails";
import EditDesinsectionRequest from "./Popups/EditDesinsectionRequest";
import RemoveDesinsectionRequest from "./Popups/RemoveDesinsectionRequest";

function createData(id, number, createdAt, departureDate, contractRequest, state, departmentHead, specialist, filial) {
    return {id, number, createdAt, departureDate, contractRequest, state, departmentHead, specialist, filial};
}

let rows = [
    createData(1, "abc", "12.03.2021 00:00", "12.03.2021 00:00", null, null, null, null, null),
];
const DesinsectionRequestList = () => {
    const {t} = useTranslation();
    const rowName = [
        {text: t("desinsectionRequestList.tableItem.id")},
        {text: t("desinsectionRequestList.tableItem.number")},
        {text: t("desinsectionRequestList.tableItem.createdAt")},
        {text: t("desinsectionRequestList.tableItem.departureDate")},
        {text: t("desinsectionRequestList.tableItem.contractRequest")},
        {text: t("desinsectionRequestList.tableItem.state")},
        {text: t("desinsectionRequestList.tableItem.departmentHead")},
        {text: t("desinsectionRequestList.tableItem.specialist")},
        {text: t("desinsectionRequestList.tableItem.filial")},
        {text: t("desinsectionRequestList.tableItem.actions")},
    ];
    const dispatch = useDispatch();

    const [query, setQuery] = useState({ "sort": { "id": { "operator": "asc" } } });

    const [id, setId] = useState(null);
    const [createOpen, setCreateOpen] = useState(false);
    const setCreateHandler = async () => {
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setCreateOpen(true);
        setId(null);
    }
    const createSubmit = async (_) => {
        await dispatch(addDesinsectionRequest(_, query));
    }
    const [detailsOpen, setDetailsOpen] = useState(false);
    const setDetailsHandler = async (id) => {
        await dispatch(getDesinsectionRequestByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setDetailsOpen(true);
        setId(id);
    }
    
    const [editOpen, setEditOpen] = useState(false);
    const setEditHandler = async (id) => {
        await dispatch(getDesinsectionRequestByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setEditOpen(true);
        setId(id);
    }
    const editSubmit = async (_) => {
        await dispatch(editDesinsectionRequest(_, query));
    }
    const [removeOpen, setRemoveOpen] = useState(false);
    const setRemoveHandler = async (id) => {
        await dispatch(getDesinsectionRequestByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setRemoveOpen(true);
        setId(id);
    }
    const removeSubmit = async (_) => {
        await dispatch(deleteDesinsectionRequest(_.id, query));
    }

    const localData = false;
    const state = useSelector((state) => state.desinsectionRequest);
    if (!localData && state.desinsectionRequests)
    {
        rows = state.desinsectionRequests;
    }
    useEffect(() => {
        if (!localData)
        {
            dispatch(getDesinsectionRequests(query));
        }
    }, [dispatch]);
    return (
        <DashboardLayout>
            <Box sx={{margin: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <SearchPanel searchName="id" search={rows} label={t("desinsectionRequestList.searchLabel")}/>
                <Button color="primary" variant="contained" onClick={() => setCreateHandler()}>
                    {t("desinsectionRequestList.createText")}
                </Button>
            </Box>
            <TableCustom avatars={false} rowName={rowName} rows={rows.map(_ => {
                return {
                    id: _.id,
                    number: _.number,
                    createdAt: _.createdAt,
                    departureDate: _.departureDate,
                    contractRequest: _.contractRequest?.number,
                    state: _.state?.name,
                    departmentHead: _.departmentHead?.fullName,
                    specialist: _.specialist?.fullName,
                    filial: _.filial?.name,
                }
            })} actions={(_) => [<VisibilityIcon onClick={() => setDetailsHandler(_.id)}/>,<EditIcon onClick={() => setEditHandler(_.id)}/>,<DeleteForeverIcon onClick={() => setRemoveHandler(_.id)}/>]}/>
            <CreateDesinsectionRequest action={'create'} title={t("desinsectionRequestList.createText")} open={createOpen} setOpen={setCreateOpen} onSubmit={createSubmit}/>
            <DesinsectionRequestDetails action={'details'} title={t("desinsectionRequestList.detailsText")} open={detailsOpen} setOpen={setDetailsOpen} />
            <EditDesinsectionRequest action={'edit'} title={t("desinsectionRequestList.editText")} open={editOpen} setOpen={setEditOpen} onSubmit={editSubmit}/>
            <RemoveDesinsectionRequest action={'remove'} title={t("desinsectionRequestList.removeText")} open={removeOpen} setOpen={setRemoveOpen} onSubmit={removeSubmit}/>
        </DashboardLayout>
    )
};

export default DesinsectionRequestList;
